import React from 'react';
import moment from 'moment';

import {AppContext} from '../../AppModule/Context';

import VideoSliderComponent from './videoSliderComponent';

import callRecordingService from '../../services/restServices/callRecordingService';
import cnameInstanceService from '../../services/restServices/cnameInstanceService';
import publicMediaLinkService from '../../services/restServices/publicMediaLinkService';

import VIDABOO_CONSTANTS from '../../config/consts';
import arrowIcon from '../../assets/svg/icons/right-arrow.svg';
import FullScreenIcon from '../../assets/svg/full-screen.svg';
import MenuIcon from '../../assets/svg/menu-video-player.svg';
import NextIcon from '../../assets/svg/seek-next.svg';
import PauseIcon from '../../assets/svg/pause-button.svg';
import PlayIcon from '../../assets/svg/play-button.svg';
import PlayIconOnPoster from '../../assets/svg/play-button-on-poster.svg';

import './videoPlayerComponent.css';

class VideoPlayerComponent extends React.PureComponent {
  constructor() {
    super();
    this.videoPlayerRef = React.createRef();
    this.videoContainerRef = React.createRef();
    this.state = {
      videoProgress: 0,
      videoTimer: '...',
      videoTimeDuration: '...',
      videoSendTime: '',
      maxProgress: 0,
      playOrPauseIcon: PlayIcon,
      init: true,
      showMenu: false,
    };
    this.dropDownMenuRef = React.createRef();
  }

  componentDidMount = () => {
    if (this.props.videoPlayerURL) {
      this.subscribeEvents();
    }
    if (this.props.funcObj) {
      this.props.funcObj.handleVideoSeek = this.seekToTime;
      this.props.funcObj.handleDeleteRecording = this.handleDelete;
    }
    window.addEventListener('click', this.handleOutsideEvent);
  };

  componentWillUnmount() {
    window.removeEventListener('click', this.handleOutsideEvent);
    this.videoPlayerRef.current.removeEventListener(
      'timeupdate',
      this.handleTimeUpdateEvent,
    );
    this.videoPlayerRef.current.removeEventListener(
      'loadedmetadata',
      this.handleLoadMetadataEvent,
    );
    this.videoPlayerRef.current.removeEventListener(
      'ended',
      this.handleVideoEndedEvent,
    );
    window.removeEventListener('error', this.handleError);
  }

  handleOutsideEvent = (e) => {
    if (
      this.dropDownMenuRef.current &&
      !this.dropDownMenuRef.current.contains(e.target) &&
      this.state.showMenu &&
      !e.target.classList.contains('et-video-player-controls-icon-menu')
    ) {
      this.showHideMenu();
    }
  };

  handleTimeUpdateEvent = () => {
    this.setVideoProgressBarOnTimeUpdateOrInit();
    this.setVideoElapsedTimer();
    if (this.props.funcObj?.handleTranscriptionSeek) {
      this.props.funcObj.handleTranscriptionSeek(
        this.videoPlayerRef.current.currentTime,
      );
    }
  };
  setSpeculativeVideoProgressBarTime = (progress) => {
    this.setState({
      videoProgress: (progress / this.videoPlayerRef.current.duration) * 100,
    });
  };

  handleLoadMetadataEvent = () => {
    console.debug('loaded meta data');
    this.initializeVideoPlayer();
  };
  handleVideoEndedEvent = () => {
    this.setState({playOrPauseIcon: PlayIcon});
  };
  handleError = (message, source, lineno, colno, error) => {
    console.debug(message, source, lineno, colno, error);
  };
  subscribeEvents = () => {
    this.videoPlayerRef.current.addEventListener(
      'timeupdate',
      this.handleTimeUpdateEvent,
    );
    this.videoPlayerRef.current.addEventListener(
      'loadedmetadata',
      this.handleLoadMetadataEvent,
    );
    this.videoPlayerRef.current.addEventListener(
      'ended',
      this.handleVideoEndedEvent,
    );
    window.addEventListener('error', this.handleError);
  };
  componentDidUpdate(prevProps) {
    if (
      this.props.videoPlayerURL !== prevProps.videoPlayerURL &&
      !!this.props.videoPlayerURL
    ) {
      this.subscribeEvents();
    }
  }
  initializeVideoPlayer = () => {
    this.setState({maxProgress: this.videoPlayerRef.current?.duration});
    this.setVideoDurationTimer();
    this.setVideoElapsedTimer();
    this.setVideoProgressBarOnTimeUpdateOrInit();
  };
  setVideoProgressBarOnTimeUpdateOrInit = () => {
    this.setState({
      videoProgress:
        (this.videoPlayerRef.current.currentTime /
          this.videoPlayerRef.current.duration) *
        100,
    });
  };
  setVideoElapsedTimer = () => {
    const time = this.formatTime(
      Math.round(this.videoPlayerRef.current.currentTime),
    );

    let obj = {
      videoTimer: `${time.minutes}:${time.seconds}`,
    };
    if (this.props.type === 'media') {
      const sendTime = moment(
        this.props.chatMessageDto.senderCreationTime,
      ).format('h:mm A');
      obj.videoSendTime = sendTime;
    }

    this.setState(obj);
  };
  setVideoDurationTimer = () => {
    const videoDuration = Math.round(this.videoPlayerRef.current.duration);
    const time = this.formatTime(videoDuration);
    this.setState({videoTimeDuration: `${time.minutes}:${time.seconds}`});
  };
  formatTime = (timeInSeconds) => {
    const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);

    return {
      minutes: result.substr(3, 2),
      seconds: result.substr(6, 2),
    };
  };
  toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      this.videoContainerRef.current.style.border = '';
      this.videoContainerRef.current.style.borderRadius = '';
      this.setState({fullscreenElement: false});
    } else {
      this.videoContainerRef.current.requestFullscreen();
      this.videoContainerRef.current.style.border = 'none';
      this.videoContainerRef.current.style.borderRadius = 'none';
      this.setState({fullscreenElement: true});
    }
  };
  handlePlayPause = () => {
    this.setState({init: false});
    if (this.videoPlayerRef.current.paused) {
      this.videoPlayerRef.current.play();
      this.setState({playOrPauseIcon: PauseIcon});
    } else {
      this.videoPlayerRef.current.pause();
      this.setState({playOrPauseIcon: PlayIcon});
    }
  };

  handleSeek = (seekValue) => () => {
    this.videoPlayerRef.current.currentTime += +seekValue;
  };

  seekToTime = (timeInSeconds) => {
    if (this.videoPlayerRef.current) {
      this.videoPlayerRef.current.currentTime = timeInSeconds;
    }
  };

  setProgress = (value) => {
    this.setSpeculativeVideoProgressBarTime(value);
    this.videoPlayerRef.current.currentTime = value;
  };
  showHideMenu = () => {
    this.setState((state) => ({
      showMenu: !state.showMenu,
    }));
  };
  handleDownload = async () => {
    this.showHideMenu();
    const callRecordingDto =
      await callRecordingService.getCallRecordingByCallRecordingId(
        this.props.callRecordingId,
      );
    if (callRecordingDto) {
      const a = document.createElement('a');
      a.setAttribute('download', 'downloadIt');
      a.setAttribute('target', '_blank');
      a.href =
        VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
        callRecordingDto.tempAccessibleDownloadUrl;
      document.body.append(a);
      a.click();
      a.remove();
    } else {
      //todo: handle error with notification
      console.debug(
        'Error in fetching call-recording: ' + this.state.callRecordingId,
      );
    }
  };

  handleShare = async () => {
    this.showHideMenu();
    const response = await publicMediaLinkService.createPublicMediaLink(
      this.props.chatMessageDto.chatMessageId,
    );
    const domainUrl = await cnameInstanceService.getDomainUrlByWidgetId(
      this.props.videoMsgWidgetId,
    );
    this.props.updateShareLink(
      domainUrl + `/media/${response.publicMediaAccessString}`,
    );
  };
  handleDelete = (callRecordingId) => {
    this.showHideMenu();
    this.context.setNotificationPopUpData({
      notificationTxt: 'Are you sure you would like to delete this recording?',
      notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
      rejectBtnTxt: 'Delete',
      rejectBtnFunc: async () => {
        this.context.setNotificationPopUpData({
          ...this.context.notificationPopUpData,
          showRejectBtnSpinner: true,
        });
        const response =
          await callRecordingService.deleteCallRecordingByCallRecordingId(
            callRecordingId,
          );
        if (response?.status === 'SUCCESS') {
          if (this.props?.setSavingStatus)
            this.props.setSavingStatus('DELETED');
        } else {
          console.debug('Error in removing call recording: ' + response);
        }
        this.context.closeNotificationPopUp();
      },
      closeBtnTxt: 'Close',
      closeBtnFunc: () => {
        this.context.closeNotificationPopUp();
      },
    });
    this.context.setShowNotificationPopUp(true);
  };

  render() {
    const {videoSendTime, videoTimeDuration} = this.state;
    const timeSplit = videoTimeDuration.split(':');
    let timeFormat = 's';
    if (timeSplit.length > 0) {
      if (parseInt(timeSplit[0]) > 0) {
        timeFormat = 'min';
      }
    }
    return (
      <div
        className={
          'et-video-player-container ' +
          (this.state.fullscreenElement ? 'et-video-player-container-full' : '')
        }
        ref={this.videoContainerRef}
        onClick={(e) => e.stopPropagation()}>
        {this.state.init && (
          <div className="et-play-button-on-poster">
            <img
              src={PlayIconOnPoster}
              onClick={this.handlePlayPause}
              alt="PlayIconOnPoster"
            />
          </div>
        )}
        <div className="et-video-player">
          {this.props.videoPlayerURL && (
            <video
              ref={this.videoPlayerRef}
              preload="metadata"
              poster={
                VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
                this.props.videPlayerPosterUrl
              }
              onClick={this.state.init ? () => {} : this.handlePlayPause}
              src={
                VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
                this.props.videoPlayerURL
              }
              type="video/mp4"></video>
          )}
          <div
            className={`et-video-player-controls ${
              this.state.fullscreenElement
                ? 'et-video-player-controls-fullscreen'
                : ''
            }`}>
            <VideoSliderComponent
              progressValue={this.state.videoProgress}
              setProgress={this.setProgress}
              maxProgress={this.state.maxProgress}
            />
            <div className="et-video-player-lower-controls">
              <div className="et-video-player-lower-controls-timer">
                {this.state.videoTimer} / {this.state.videoTimeDuration}
              </div>
              <div className="et-video-player-lower-controls-buttons">
                <img
                  src={NextIcon}
                  alt="NextIcon"
                  onClick={this.handleSeek(-10)}
                  className="et-video-player-controls-icon et-video-player-controls-prev-icon"
                />
                <img
                  src={this.state.playOrPauseIcon}
                  alt="playOrPauseIcon"
                  className="et-video-player-controls-icon et-video-player-controls-play-icon"
                  onClick={this.handlePlayPause}
                />
                <img
                  src={NextIcon}
                  alt="NextIcon"
                  onClick={this.handleSeek(10)}
                  className="et-video-player-controls-icon et-video-player-controls-next-icon"
                />
              </div>
              <div className="et-video-player-lower-controls-menu">
                <img
                  src={FullScreenIcon}
                  alt="FullScreenIcon"
                  className="et-video-player-controls-icon "
                  onClick={this.toggleFullscreen}
                />
                {this.props.showDropDownMenu !== false && (
                  <img
                    src={MenuIcon}
                    alt="MenuIcon"
                    className="et-video-player-controls-icon et-video-player-controls-icon-menu"
                    onClick={this.showHideMenu}
                  />
                )}
              </div>
            </div>
          </div>
          {this.state.showMenu && this.props.showDropDownMenu !== false && (
            <div
              className="et-dropdown-menu-video-player"
              ref={this.dropDownMenuRef}>
              <ul className="et-dropdown-menu-video-player-list-wrapper">
                <li
                  className="et-dropdown-menu-video-player-list-item"
                  onClick={this.handleDownload}>
                  Download
                </li>
                <li
                  className="et-dropdown-menu-video-player-list-item"
                  onClick={this.props.showSendEmailPopup}>
                  Send by email
                </li>
                <li
                  className="et-dropdown-menu-video-player-list-item"
                  onClick={this.handleShare}>
                  Share
                </li>
                <li
                  className="et-dropdown-menu-video-player-list-item"
                  onClick={() => this.handleDelete(this.props.callRecordingId)}>
                  Delete
                </li>
              </ul>
            </div>
          )}
        </div>
        {this.props.type === 'media' && (
          <div className="et-pm-wrap">
            <img
              onClick={() =>
                this.props.goToMessage(this.props.chatMessageDto.chatMessageId)
              }
              src={arrowIcon}
              className="et-drmbil-arrow-img"
              alt="media"
            />
            <div className="et-pm-time-format-wrap">
              <p className="et-pm-message-time">
                {this.state.videoTimeDuration}
                {timeFormat}
              </p>
              <p className="et-pm-message-time">{videoSendTime}</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

VideoPlayerComponent.contextType = AppContext;
export default VideoPlayerComponent;
